import { gql } from 'apollo-angular';

export const UPDATE_ACTIVITY_MUTEX = gql`
  mutation UpdateActivityMutex($activityId: String!, $displayStatus: String) {
    updateActivity(activityId: $activityId, displayStatus: $displayStatus) {
      activityId
      displayStatus
    }
  }
`;

export const GET_WORD_METADATA = gql`
  query WordQuery($word: String!) {
    word(WORD: $word) {
      items {
        WORD
        PHON
        NPHON
        MORPHEME
        PHONEME_VIDEO_URL
      }
    }
  }
`;

export default {
  UPDATE_ACTIVITY_MUTEX,
  GET_WORD_METADATA,
};
